import { create } from "zustand";
import { immer } from "zustand/middleware/immer";

import { useBuilderStore } from "./builder";

type PageState = {
  currentPage: number;
};

type PageActions = {
  setPage: (page: number, totalPages: number) => void;
  nextPage: (totalPages: number) => void;
  prevPage: () => void;
  validatePage: (totalPages: number) => void;
  syncToArtboard: () => void;
};

export type PageStore = PageState & PageActions;

const postPageToArtboard = (page: number) => {
  const frameRef = useBuilderStore.getState().frame.ref;
  frameRef?.contentWindow?.postMessage({ type: "SET_PAGE", payload: { currentPage: page } }, "*");
};

export const usePageStore = create<PageStore>()(
  immer((set, get) => ({
    currentPage: 1,

    setPage: (page, totalPages) => {
      const validPage = Math.max(1, Math.min(page, totalPages || 1));
      set((state) => {
        state.currentPage = validPage;
      });
      postPageToArtboard(validPage);
    },

    nextPage: (totalPages) => {
      const next = Math.min(get().currentPage + 1, totalPages || 1);
      set((state) => {
        state.currentPage = next;
      });
      postPageToArtboard(next);
    },

    prevPage: () => {
      const prev = Math.max(get().currentPage - 1, 1);
      set((state) => {
        state.currentPage = prev;
      });
      postPageToArtboard(prev);
    },

    validatePage: (totalPages) => {
      const current = get().currentPage;
      const validPage = Math.max(1, Math.min(current, totalPages || 1));
      console.log(totalPages);
      if (current !== validPage) {
        set((state) => {
          state.currentPage = validPage;
        });
        console.log(validPage);
        postPageToArtboard(validPage);
      }
    },

    syncToArtboard: () => {
      postPageToArtboard(get().currentPage);
    },
  })),
);
